// extracted by mini-css-extract-plugin
module.exports = {"links":"Socials_links__3uX6H","hvr-bob":"Socials_hvr-bob__34PRT","hvr-bob-float":"Socials_hvr-bob-float__2kHWd"};